import { put, delay, takeLatest } from "@redux-saga/core/effects";
import { Actions, Types } from "../../Reducer/User";
import { User } from "../../../Types/UnitFeatureTypes";
import { userSignIn, verifyToken } from "../../../Utils/BackendAPICalls";


  interface UserCredentials {
    email: string;
    password: string;
  }
  
  interface FetchActiveUserAction {
    payload: UserCredentials;
  }

  interface EditActiveUserAction {
    payload: {
      user: User;
    };
  }

  interface UpdatePasswordActiveUserAction {
    payload: {
      token: string;
      currentPassword: string;
      newPassword: string;
    };
  }

export function* loginUserRequest(action: FetchActiveUserAction): Generator<any, void, Response> {
    const { email, password } = action.payload;   

    try {
        yield delay(100);

        const response: any = yield userSignIn({email, password});

        if (!response || response.error) {
            const error = { message: response.error };
            yield put(Actions.fetchUser.userLoginAction.failure(error));
        } 
        if (response && response.token) {
            localStorage.setItem('token', response.token);
            yield put(
              Actions.fetchUser.userLoginAction.success({
                  token: response.token,
              })
            );
        } else {
          yield put(Actions.fetchUser.userLoginAction.failure({message: response.error}));
        }
        
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchUser.userLoginAction.failure(error));
    }
  
}

export function* verifyUserRequest(action: {payload: {token: string}}): Generator<any, void, Response> {
  const { token } = action.payload;   

  try {
      yield delay(100);

      if (token) {
          const response: any = yield verifyToken(token);
          if (!response) {
              Actions.fetchUser.verifyUserTokenAction.failure({message: "Invalid Token"});
              localStorage.removeItem('token');
              throw new Error("Invalid Token");
          } 
          yield put(
            Actions.fetchUser.verifyUserTokenAction.success({
                user: response?.user,
            })
          );
}
      
  } catch (err) {
      const error = { message: "Something went wrong." };
      yield put(Actions.fetchUser.verifyUserTokenAction.failure(error));
  }

}

// export function* editUserRequest(action: EditActiveUserAction ): Generator<any, void, Response> {
//   const { user } = action.payload;
//     try {
//         const token = localStorage.getItem('token');
//         yield delay(100);
//         if (!token) {
//             yield put(Actions.fetch.editUserActions.failure({message: "No token found"}));
//             throw new Error("No token found");
//         }
//         const response = yield editUser({token, user});

//         if (!response || response.error) {
//             const error = { message: response.error };
//             yield put(Actions.fetch.editUserActions.failure(error));
//         }

//         if (response && response.isSuccess) {
//             yield put(
//               Actions.fetch.editUserActions.success({
//                   isSuccess: response.isSuccess,
//                   user: response.user,
//               })
//             );
//         } else {
//           yield put(Actions.fetch.editUserActions.failure({message: response.error}));
//         }

//     } catch (err) {
//         const error = { message: "fatalFailure" };
//         yield put(Actions.fetch.userActions.failure(error));
//     }
// }

// export function* updatePasswordRequest(action: UpdatePasswordActiveUserAction): Generator<any, void, Response> {
//   const { currentPassword, newPassword } = action.payload;   

//   try {
//       yield delay(100);
//       const token = localStorage.getItem('token');
//       if (!token) {
//           yield put(Actions.fetch.updatePasswordActions.failure({message: "No token found"}));
//           throw new Error("No token found");
//       }
//       const response = yield userUpdatePassword(token, currentPassword, newPassword);

//       if (!response || response.error) {
//           const error = { message: response.error };
//           yield put(Actions.fetch.updatePasswordActions.failure(error));
//       }

//       if (response && response.isSuccess) {
//           yield put(
//             Actions.fetch.updatePasswordActions.success({
//                 isSuccess: response.isSuccess,
//             })
//           );
//       } else {
//         yield put(Actions.fetch.updatePasswordActions.failure({message: response.error}));
//       }
      
//   } catch (err) {
//       const error = { message: "Something went wrong." };
//       yield put(Actions.fetch.updatePasswordActions.failure(error));
//   }
// }



export default function* userSaga() {
    yield takeLatest(Types.FETCH_USER_REQUEST, loginUserRequest);
    yield takeLatest(Types.VERIFY_USER_REQUEST, verifyUserRequest);
    // yield takeLatest(Types.EDIT_USER_REQUEST, editUserRequest);
    // yield takeLatest(Types.UPDATE_PASSWORD_REQUEST, updatePasswordRequest);
}
